
//each snapshot is going to be limited to what type of change it is

import {
    Icon,
    Label,
    mergeStyles, Text,
    useTheme
} from '@fluentui/react';
import hslDefault from 'assets/SVGPack/hslDefault.svg';
import hslExcel from 'assets/SVGPack/hslExcel.svg';
import hslPDF from 'assets/SVGPack/hslPDF.svg';
import hslUnknown from 'assets/SVGPack/hslUnknown.svg';
import * as React from 'react';
import { useState } from 'react';
import Dropzone from 'react-dropzone';
import { formatBytes } from '../../../global/Utility/JSFunctions';


export interface IFileBlob extends Blob {
    name: string;
    path: string;
    lastModifiedDate: Date;
    size: number;
    type: string;
}

interface IProps {
    onDropBase64?: (file: string, name: string) => void;
    onDropAsBlob?: (file: IFileBlob) => void;
    maxFiles?: number;
    showAttached?: boolean;
}

const FileImportDialog: React.FunctionComponent<IProps> = (props) => {

    const theme = useTheme();
    const [files, setFiles] = useState<IFileBlob[] | null>(null);

    const AttachmentCard = mergeStyles({
        padding: '10px',
        borderRadius: '4px',
        overflow: 'visible',
        boxShadow: theme.effects.elevation8,
        marginBottom: '15px',
        marginTop: '15px',
    });

    const DZMessage = mergeStyles({
        padding: '3rem 1rem',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        textAlign: 'center',
        color: '#d1d2db',
        border: '1px dashed #e6e7f1',
        borderRadius: '.65rem',
        backgroundColor: theme.semanticColors.buttonBackground,
        fontSize: '1.1875rem',
        order: -1,
        "&:hover": {
            borderColor: '#0082CA',
            color: '#7a7b97'
        }

    });

    const onDrop = (files: IFileBlob[]) => {

        setFiles(files);

        files.forEach(eachFile => {

            const reader = new FileReader()
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')

            if (props.onDropBase64) {
                reader.onload = () => {
                    const base64url = reader.result as string;

                    // format is "data:application/octet-stream;base64,<your base64 data>"
                    let base64: string = base64url.split(",", 2)[1];

                    props.onDropBase64?.(base64, eachFile.name);
                }

                reader.readAsDataURL(eachFile);
            }

            if (props.onDropAsBlob) {
                props.onDropAsBlob(eachFile);
            }

        });

    }

    const renderIcon = (name: string | null) => {
        let src = hslDefault;

        switch ((name ?? '').split('.').pop()?.toLowerCase()) {
            case 'xlsx':
                src = hslExcel;
                break;

            case 'ods':
                src = hslExcel;
                break;

            case 'xlsm':
                src = hslExcel;
                break;

            case 'xls':
                src = hslExcel;
                break;

            case 'pdf':
                src = hslPDF;
                break;

            default:
                src = hslUnknown;
                break;
        }

        return <img
            src={src}
            style={{ width: '60px' }}
            alt={"application icon"}
        />;

    }

    return (
        <div>
            <Text block styles={{ root: { marginTop: '8px', marginBottom: '8px' } }} >
                Use the area below to upload your document.
            </Text>
            <div className={AttachmentCard}>
                <div style={{ marginBottom: '20px', }}>
                    <Dropzone
                        onDrop={onDrop.bind(this as any) as any}
                        maxFiles={props.maxFiles ?? 1}
                        multiple={(props.maxFiles ?? 0) > 1 ? true : false}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} style={{ outline: 'none' }}>
                                <input {...getInputProps()} />
                                <div className={DZMessage}>
                                    <div>
                                        <Icon style={{ fontSize: '30px' }} iconName="CloudImportExport" />
                                        <div>Drop your file here</div>
                                        <div>Click to select file to upload.</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </div>
                {props.showAttached && files && files.length > 0 &&
                    files.map((eachFile, ix) => {
                        return <div key={ix} style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '15px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignSelf: 'center' }}>
                                <div>
                                    {renderIcon(eachFile.name)}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'start', alignSelf: 'center' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr', width: '100%' }}>
                                    <Label >{eachFile.name}</Label>
                                    <Label style={{ color: 'gray' }}>{formatBytes(eachFile.size)}</Label>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    );
};

export default FileImportDialog;